// extracted by mini-css-extract-plugin
module.exports = {"delta2Kit":"delta2Kit_delta2Kit__QPs_u"};